module.exports = __webpack_public_path__ + "img/smis-hub-logo.734b6012.svg";